import {AppStore} from "../../desktop";
import {ServicesActionTypes} from ".";
import {Service} from "../../models/Service";
import {TabsActionTypes} from "../tabs";

export const actionServiceFetchAll = () => {
	AppStore.dispatch({type: ServicesActionTypes.FETCH_ALL_REQUEST, payload: null})
}

export const actionServiceFetchAllCompleted = (services: Service[]) => {
	AppStore.dispatch({type: ServicesActionTypes.FETCH_ALL_COMPLETED, payload: services})
}

export const actionServiceFetch = (service: Service) => {
	AppStore.dispatch({type: ServicesActionTypes.FETCH_ONE_REQUEST, payload: service})
}

export const actionServiceFetchCompleted = (service: Service) => {
	AppStore.dispatch({type: ServicesActionTypes.FETCH_ONE_COMPLETED, payload: service})
	AppStore.dispatch({type: TabsActionTypes.SET_TAB_ITEM, payload: service})
}

export const actionSaveService = (service: Service) => {
	AppStore.dispatch({type: ServicesActionTypes.SAVE_REQUEST, payload: service})
}

export const actionDeleteService = (service: Service) => {
	AppStore.dispatch({type: ServicesActionTypes.DELETE_REQUEST, payload: service})
}

export const actionDeleteServices = (services: Service[]) => {
	AppStore.dispatch({type: ServicesActionTypes.DELETE_MULTIPLE_REQUEST, payload: services})
}